import React, { useState, useEffect } from 'react';
import { Icon, Menu, Sidebar, SidebarPusher } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import auth from './../Login/auth';
import { SaldoIndividual } from './../SaldoIndividual/SaldoIndividual';
import { NotasVtaEmitidas } from './../NotasVtaEmitidas/NotasVtaEmitidas';
import { CuentaCorriente } from './../CuentaCorriente/CuentaCorriente';
import { EstadoAvance } from '../EstadoAvance/EstadoAvance';

export const Home = props => {
    const [renderTab, setRenderTab] = useState('');
    //const [items, setItems] = useState(0);

    // De forma similar a componentDidMount y componentDidUpdate
    useEffect(() => {
        //setItems(auth.items);
    });

    function handleLogout(){
        auth.logout(() => {
            props.history.push("/");
        });
    }

    function handleClick (e, { name }) {
        e.preventDefault();
        setRenderTab(name);
    };
    
    return(
        <div >
            <Sidebar as={Menu} inverted visible vertical width="thin" icon="labeled" animation="push">
                
                <div> 
                    {auth.usuario.items.map((item) =>{ 
                        return(
                            <Menu.Item name={item.nombre_pagina} onClick={handleClick}> 
                                <Icon name={item.icono} />
                                {item.desc_item}
                            </Menu.Item>
                    )})}                                
                </div>
                <Menu.Item name="logout" onClick={handleLogout}>
                    <Icon name="power" />
                    Cerrar Sesión
                </Menu.Item>
            </Sidebar>
            <SidebarPusher>
                <RenderedContent tabName={renderTab} />
            </SidebarPusher>
        </div>
    );
}

const RenderedContent = (tabName) => {
    
    if (tabName.tabName === 'ctacte') {
        return <CuentaCorriente />
    }
    if (tabName.tabName === 'avance') {
        return <EstadoAvance />
    }
    if (tabName.tabName === 'nvemitidas') {
        return <NotasVtaEmitidas />
    }if (tabName.tabName === 'saldo') {
        return <SaldoIndividual />
    }else {
        return <About />
    }
    
}

const About = () => (
    <div>
        Bienvenido <h5>{auth.nombre}</h5> 
    </div>
)